import { createServerSideHelpers } from "@trpc/react-query/server";
import type { GetServerSidePropsContext } from "next";
import superjson from "superjson";

import { appRouter } from "~/server/trpc/root";
import { createTRPCContext } from "~/server/trpc/trpc";

export async function getServerSideProps(context: GetServerSidePropsContext<{ deckId: string }>) {
  const id = context.params?.deckId;

  if (!id) {
    return { notFound: true };
  }

  // create ssg helpers
  const ssg = createServerSideHelpers({
    router: appRouter,
    // skip ip checks in SSR trpc pre-caching requests
    ctx: await createTRPCContext({ isSSR: true }),
    transformer: superjson, // optional - adds superjson serialization
  });

  // prefetch so jotai can instantly hydrate
  const deck = await ssg.deck.getById.fetch({ id });

  // If the data is not found, redirect to a 404 page
  if (!deck) {
    return { notFound: true };
  }

  return {
    props: {
      deckId: id,
      trpcState: ssg.dehydrate(),
    },
  };
}

export { default } from "./Deck";
